/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { memo } from 'react';
import { ContextualAnalyticsData } from '@jira/navigation-apps__sidebar-common/src/ui/contextual-analytics-data/index.tsx';
import { SidebarBoundary } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { Skeleton } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-common/src/common/ui/skeleton/index.tsx';
import { MENU_ID_JSM_SETTINGS } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-project-common/src/constants.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Props } from './main.tsx';

const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-jsm-cmp-project-settings" */ './main.tsx'
		).then(({ JSMCmpProjectSettingsSidebar }) => JSMCmpProjectSettingsSidebar),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

const analyticsAttributes = {
	projectStyle: 'cmp',
	// reset '3' being sent from outside-of-nav4 Context. navState is used instead.
	// @deprecated cleanup this attribute on jira_nav4 FG / Nav3 cleanup. navState is used instead
	navVersion: undefined,
};

export const AsyncJsmCmpProjectSettingsSidebar: React.MemoExoticComponent<
	({ project }: Props) => React.JSX.Element
> = memo(
	({ project }: Props): React.JSX.Element => (
		<SidebarBoundary
			id="nav4.sidebar.jsm-cmp-project-settings"
			packageName="jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
			teamName="jsm-grape-soju"
			ufoName="nav4.sidebar.jsm-cmp-project-settings"
		>
			<ContextualAnalyticsData menuId={MENU_ID_JSM_SETTINGS} attributes={analyticsAttributes}>
				<Placeholder
					name="nav4.sidebar.jsm-cmp-project-settings.loading-lazy"
					fallback={<Skeleton />}
				>
					<LazySidebarContent project={project} />
				</Placeholder>
			</ContextualAnalyticsData>
		</SidebarBoundary>
	),
);
